import React from 'react';

type Props = {
  size?: number;
  rotate?: number;
};

const ChevronDownV2Icon: React.FC<Props> = ({ size = 16, rotate = 0 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: `rotate(${rotate}deg)`
    }}
  >
    <path d="M4 6L8 10L12 6" stroke="#475467" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ChevronDownV2Icon;
